// 邮箱打码工具函数
const desensitizeEmail = (email) => {
  // 如果没有邮箱，直接返回
  if (!email) return ''

  // 拆分 用户名@域名
  const [name, domain] = email.split('@')

  // 用户名长度 <= 2 → 只留第一个字符
  if (name.length <= 2) {
    return `${name[0]}***@${domain}`
  }

  // 用户名长度 > 2 → 保留首尾字符，中间打码
  return `${name[0]}***${name.slice(-1)}@${domain}`
}

export { desensitizeEmail };
